export default {"src":"/polygon/_next/static/media/matic-circular.4147c0da.svg","height":28,"width":28};